<template>
  <div>
  <div class="nav-cover" :class="{coverOn: activeSearch}" ref="coverBG" @click="clearSearch()"></div>
  <b-container fluid class="nav-container">
    <b-navbar id="main-nav" toggleable="lg" type="dark" variant="secondary">
      <b-navbar-brand :to="{ name: 'home'}">
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 446.02 86.36" aria-labelledby="cs-logo-title" role="img">
          <title id="cs-logo-title">Columbus State Community College Logo</title>
          <rect class="cls-1" y="54.4" width="446.02" height="2.62"></rect>
          <path class="cls-1" d="M72.42,88.94a6.91,6.91,0,0,1,7.24-7,6.22,6.22,0,0,1,5.69,3.33l-2.49,1.23a3.69,3.69,0,0,0-3.2-2,4.47,4.47,0,0,0,0,8.94,3.65,3.65,0,0,0,3.2-2l2.49,1.21A6.27,6.27,0,0,1,79.66,96,6.91,6.91,0,0,1,72.42,88.94Z" transform="translate(-10.37 -9.64)"></path>
          <path class="cls-1" d="M92.95,88.94a7.11,7.11,0,1,1,7.1,7A6.83,6.83,0,0,1,92.95,88.94Zm11.24,0c0-2.55-1.63-4.47-4.14-4.47s-4.12,1.92-4.12,4.47,1.61,4.47,4.12,4.47A4.14,4.14,0,0,0,104.19,88.94Z" transform="translate(-10.37 -9.64)"></path><path class="cls-1" d="M126.74,95.74V86.21l-3.84,9.53h-1.26l-3.84-9.53v9.53h-2.9V82.13H119l3.31,8.22,3.31-8.22h4.08V95.74Z" transform="translate(-10.37 -9.64)"></path><path class="cls-1" d="M150.69,95.74V86.21l-3.84,9.53h-1.26l-3.84-9.53v9.53h-2.9V82.13h4.06l3.31,8.22,3.3-8.22h4.08V95.74Z" transform="translate(-10.37 -9.64)"></path><path class="cls-1" d="M162.81,90.31V82.13h2.94v8.08a3.19,3.19,0,1,0,6.39,0V82.13h3v8.16c0,3.39-2,5.69-6.14,5.69S162.81,93.65,162.81,90.31Z" transform="translate(-10.37 -9.64)"></path><path class="cls-1" d="M193.67,95.74l-6.49-8.88v8.88h-2.9V82.13h3l6.3,8.55V82.13h2.9V95.74Z" transform="translate(-10.37 -9.64)"></path><path class="cls-1" d="M206.07,95.74V82.13H209V95.74Z" transform="translate(-10.37 -9.64)"></path><path class="cls-1" d="M221.73,95.74V84.68h-4V82.13h10.85v2.55h-4V95.74Z" transform="translate(-10.37 -9.64)"></path><path class="cls-1" d="M240.77,95.74V90.16l-5.24-8h3.31l3.39,5.47,3.35-5.47h3.3l-5.2,8v5.57Z" transform="translate(-10.37 -9.64)"></path><path class="cls-1" d="M267.74,88.94a6.92,6.92,0,0,1,7.24-7,6.22,6.22,0,0,1,5.69,3.33l-2.49,1.23a3.69,3.69,0,0,0-3.2-2,4.47,4.47,0,0,0,0,8.94,3.65,3.65,0,0,0,3.2-2l2.49,1.21A6.27,6.27,0,0,1,275,96,6.91,6.91,0,0,1,267.74,88.94Z" transform="translate(-10.37 -9.64)"></path><path class="cls-1" d="M288.27,88.94a7.11,7.11,0,1,1,7.1,7A6.83,6.83,0,0,1,288.27,88.94Zm11.24,0c0-2.55-1.63-4.47-4.14-4.47s-4.12,1.92-4.12,4.47,1.61,4.47,4.12,4.47A4.14,4.14,0,0,0,299.51,88.94Z" transform="translate(-10.37 -9.64)"></path><path class="cls-1" d="M311,95.74V82.13h2.9V93.19h5.75v2.55Z" transform="translate(-10.37 -9.64)"></path><path class="cls-1" d="M328.64,95.74V82.13h2.9V93.19h5.75v2.55Z" transform="translate(-10.37 -9.64)"></path><path class="cls-1" d="M345.82,95.74V82.13h9.63v2.55h-6.73v2.88h6.59V90.1h-6.59v3.08h6.73v2.55Z" transform="translate(-10.37 -9.64)"></path><path class="cls-1" d="M363.17,88.94a6.9,6.9,0,0,1,7.24-7,6.36,6.36,0,0,1,5.63,3l-2.41,1.31a3.86,3.86,0,0,0-3.22-1.78,4.47,4.47,0,0,0,0,8.94,4.59,4.59,0,0,0,2.9-1V90.74h-3.59V88.21h6.49v5.22A7.56,7.56,0,0,1,370.41,96,6.93,6.93,0,0,1,363.17,88.94Z" transform="translate(-10.37 -9.64)"></path><path class="cls-1" d="M384.62,95.74V82.13h9.63v2.55h-6.73v2.88h6.59V90.1h-6.59v3.08h6.73v2.55Z" transform="translate(-10.37 -9.64)"></path><path class="cls-2" d="M59.87,19.14c0-5.13-3.38-6.82-8.74-6.82a12.54,12.54,0,0,0-9.68,3.91c-2.74,3-4.31,7.58-4.31,13.46,0,10.78,4.66,17.08,15.5,17.08a25.31,25.31,0,0,0,8.57-1.69l.52,2a27.6,27.6,0,0,1-11.66,2.51c-15.62,0-20.63-10.85-20.63-19.65a19.54,19.54,0,0,1,10-17.48c3.38-1.93,7.4-2.8,12.3-2.8,5.07,0,7.35.41,9.09.41A9,9,0,0,0,62,10s-.06,1.92-.06,2.74c0,3,.06,6.42.06,6.42Z" transform="translate(-10.37 -9.64)"></path><path class="cls-2" d="M80,49.51c-5.19,0-9.21-1.46-12.18-4.2a14.73,14.73,0,0,1-4.61-11c0-7.28,5.48-15.15,17.14-15.15,9.39,0,16.26,5.77,16.26,15C96.65,44.26,88.2,49.51,80,49.51Zm-.23-28c-6.18,0-9.56,4.14-9.56,12,0,6.53,2.45,13.76,10.08,13.76,6.24,0,9.45-4.78,9.45-12.41C89.78,29.23,87.79,21.53,79.81,21.53Z" transform="translate(-10.37 -9.64)"></path><path class="cls-2" d="M104.23,48.93c-2,0-6.35.05-6.35.05v-1.8c2.1,0,2.86-.12,3.26-1.92.29-1.11.29-5.3.29-11.95,0-7.87,0-10-.29-10.78-.41-.93-1.17-1-3.32-1V19.67s3.85.12,6.76.12c2.27,0,6.88-.12,6.88-.12v1.86c-2.27,0-3.2.06-3.56,1.4s-.35,3.85-.35,9.85c0,12.18.06,12.71.82,13.35.58.53,2.1.7,4.49.7,2.16,0,3.67-.29,4.84-1.29S119,42.34,119,42.34h2.1s-.12,2.51-.12,4.73c0,.58.12,2,.12,2S107.44,48.93,104.23,48.93Z" transform="translate(-10.37 -9.64)"></path><path class="cls-2" d="M195.28,21.53V19.67s-1.05.06-3.5.06c-2.21,0-5.07-.06-5.07-.06s-4,7.4-6.12,11.54c-2.39,4.61-5.07,9.62-5.07,9.62s-2.68-5.19-5.13-9.85c-2-4.08-5.77-11.37-5.77-11.37s-1.75.12-3.67.12c-1.56,0-9.18.06-10.78.06-2.56,0-6.53-.12-6.53-.12v1.86c2.91,0,3.9.18,4.37.93.87,1.52.76,5.48.76,11.08,0,7.87-2,13.35-9.79,13.35a8.41,8.41,0,0,1-6-2.1c-1.57-1.52-2-3.85-2.21-6.76-.12-2.1-.12-4.2-.12-6.64,0-4.44.12-6.71.47-8.22s1.16-1.63,3.38-1.63V19.67s-4.26.12-6.76.12-6.65-.12-6.65-.12v1.86c2.27,0,3.15.06,3.38,1.87a58.49,58.49,0,0,1,.17,6.64c0,2.27-.06,4.84-.06,7.58,0,3.85.52,6.94,3,9,2,1.69,5.36,2.86,10.61,2.86,5.48,0,8.92-1.86,10.72-4.08,2.16-2.68,2.91-6.59,2.91-11,0-7.46.12-10.43.58-11.72.3-.93,1.17-1.16,2.89-1.21,3.14.09,4,1.91,4,1.91s.06,2.68.06,9.85c0,9.27-.18,11.6-.58,12.65s-1.63,1.22-3.27,1.22V49s3.2-.12,5.48-.12,5.13.12,5.13.12v-1.8c-1.81,0-3-.29-3.38-1.34s-.53-5.77-.53-13.06v-4.9s3.15,6,5.13,9.86L173.71,50s4-7.4,7.35-13.81c1.63-3.09,4.14-7.81,4.14-7.81s0,1.4.06,4.61c-.06,4-.06,8.16-.12,10-.06,2-.23,3-.76,3.5-.76.81-1.4.76-2.74.76V49s3.67-.12,6.47-.12S195,49,195,49v-1.8c-1.63,0-2.86-.06-3.26-1.05-.35-.82-.35-3-.41-10.72-.06-2.68-.06-5-.06-7.29,0-4.32.29-5.36,1-6S195.28,21.53,195.28,21.53Z" transform="translate(-10.37 -9.64)"></path><path class="cls-2" d="M212.6,49.16c-1.75,0-4.55-.23-7.46-.23-2.39,0-6.41.05-6.41.05v-1.8c2.1,0,2.91-.17,3.26-1.92.23-1.11.29-4.26.29-11.95,0-7.93.06-9.91-.29-10.78s-1.17-1-3.38-1V19.67s4,.06,6.88.06c2.27.06,5.65-.18,7.75-.18,5.42,0,9.91,1.81,9.91,6.53,0,5.19-5.77,6.88-6.88,7.29,2,.35,9,1.69,9,7.17C225.24,46.89,218.19,49.16,212.6,49.16Zm-1.87-27.4c-1.4,0-2.33.06-2.33.06v10.9s.7.06,1.86.06c3.79,0,6.3-1.57,6.3-5.65S214.11,21.77,210.73,21.77ZM211,34.82c-1.17,0-2.62.06-2.62.06s0,3.32.06,6.35c.06,3.67-.23,6,3.9,6,3.09,0,6.29-1.63,6.29-6.59C218.66,36.63,215.74,34.82,211,34.82Z" transform="translate(-10.37 -9.64)"></path><path class="cls-2" d="M257,22.76c-.47,1.28-.58,4.25-.58,11.72,0,4.37-.76,8.28-2.91,11-1.81,2.22-5.25,4.08-10.72,4.08-5.25,0-8.63-1.16-10.61-2.86-2.5-2.1-3-5.19-3-9,0-2.74.06-5.31.06-7.58A57.06,57.06,0,0,0,229,23.4c-.23-1.81-1.11-1.87-3.38-1.87V19.67s4,.12,6.64.12,6.76-.12,6.76-.12v1.86c-2.21,0-3,.06-3.38,1.63s-.47,3.79-.47,8.22c0,2.44,0,4.54.12,6.64.18,2.91.64,5.25,2.22,6.76a8.4,8.4,0,0,0,6,2.1c7.81,0,9.79-5.48,9.79-13.35,0-5.6.12-9.56-.76-11.08-.47-.76-1.46-.93-4.37-.93V19.67s4,.12,6.53.12,6.24-.12,6.24-.12v1.86C258.47,21.53,257.3,21.65,257,22.76Z" transform="translate(-10.37 -9.64)"></path><path class="cls-2" d="M271.06,49.28c-5.13,0-7.23-1.16-8.63-1.16,0,0,.06-1.17.06-1.75-.06-2.39-.23-4.78-.23-4.78h2c0,3.67,2.33,5.6,7.05,5.6,4,0,5.94-1.92,5.94-4.49,0-2.22-1.22-3.38-6.7-6.59-4.37-2.51-7.11-4.67-7.11-9a6.89,6.89,0,0,1,2-4.84c1.81-1.86,4.9-2.91,9.21-2.91,4,0,4.14.18,6.94.18,0,0-.06,1.28-.06,2,0,1.57.18,4.61.18,4.61h-2a4.8,4.8,0,0,0-1.23-3.38,6.13,6.13,0,0,0-4.14-1.4c-4.37,0-5.59,1.86-5.59,3.9,0,2.91,1.69,4.08,6.41,6.76,5,2.91,7.87,5,7.87,8.57C283,45,279.4,49.28,271.06,49.28Z" transform="translate(-10.37 -9.64)"></path><path class="cls-2" d="M307.79,49.4c-4.9,0-8-1.34-10.32-1.63,0,0,.06-1.11.06-1.81-.06-3.21-.23-6.7-.23-6.7h2.21c0,5.42,3.67,7.46,8.69,7.46S316,44.38,316,40.65c0-3-1.87-4.49-8.86-9.09-5.19-3.44-8.1-6.3-8.1-11.72a9.32,9.32,0,0,1,5.19-8.16,15.4,15.4,0,0,1,8-1.86c3.67,0,5.83.52,7.46.52a6.35,6.35,0,0,0,1-.12s-.06,1.63-.06,2.5c.06,2.16.18,5.83.18,5.83h-2.33c0-3.44-1.92-6.24-6.7-6.24s-7,2.39-7,5.48c0,3.73,2.51,5.6,8.16,9.15S322.24,33,322.24,38C322.24,43.91,317.87,49.4,307.79,49.4Z" transform="translate(-10.37 -9.64)"></path><path class="cls-2" d="M351,26.43c0-2.8-1.22-4.43-4.72-4.43h-4.55s-.06,6.64-.06,10.78c0,8.57,0,11.31.23,12.47.35,1.63,1.34,1.92,3.38,1.92V49s-4.26-.12-6.88-.12S332,49,332,49v-1.8c2.1,0,2.91-.17,3.27-1.92.23-1.11.29-4.6.29-11.95V22H331c-3.5,0-4.72,1.4-4.72,4.43h-2.16s.18-2.62.18-4.9c0-.58-.12-2-.12-2s7.46.18,14.86.18c7,0,14-.23,14-.23s-.12,1.4-.12,2c0,2.33.18,5,.18,5Z" transform="translate(-10.37 -9.64)"></path><path class="cls-2" d="M377.09,48.87c-2.51,0-7.35.12-7.35.12v-1.8c2.1,0,3.61-.23,3.61-1.58,0-.7-.47-1.69-1.57-4.14-.58-1.22-1.75-4-1.75-4h-9.79s-1.17,2.33-1.87,3.91a14.29,14.29,0,0,0-1.34,4c0,1.28,1.17,1.75,4.2,1.75V49s-4.08-.12-6.53-.12c-1.8,0-5.48.12-5.48.12v-1.8a4.36,4.36,0,0,0,3.9-2c1-1.22,2.27-3.55,4.66-8.45,1.4-2.85,8.45-17,8.92-18.42h1c.47,1.22,5.07,11.19,7.4,16.32,2.16,4.72,4.37,9.44,5.6,11a3.56,3.56,0,0,0,3.09,1.52V49S380.12,48.87,377.09,48.87ZM365.26,26.95l-4.08,8.51h7.93Z" transform="translate(-10.37 -9.64)"></path><path class="cls-2" d="M407.46,26.43c0-2.8-1.23-4.43-4.72-4.43h-4.55s-.06,6.64-.06,10.78c0,8.57,0,11.31.23,12.47.35,1.63,1.34,1.92,3.38,1.92V49s-4.26-.12-6.88-.12-6.41.12-6.41.12v-1.8c2.1,0,2.92-.17,3.26-1.92.23-1.11.29-4.6.29-11.95V22h-4.55c-3.5,0-4.72,1.4-4.72,4.43h-2.16s.18-2.62.18-4.9c0-.58-.12-2-.12-2s7.46.18,14.86.18c7.05,0,14-.23,14-.23s-.12,1.4-.12,2c0,2.33.18,5,.18,5Z" transform="translate(-10.37 -9.64)"></path><path class="cls-2" d="M419.64,48.93c-2.39,0-6.41.05-6.41.05v-1.8c2.1,0,2.91-.17,3.27-1.92.23-1.11.29-4.26.29-11.95,0-8.45,0-10.08-.29-10.78s-.82-1-3.38-1V19.67s4,.06,6.88.06c2.16,0,10.26-.12,14.34-.12.53,0,1.52-.06,1.52-.06s-.12,1.17-.12,1.75c0,2.33.17,4.43.17,4.43h-2.1c0-3.15-1.17-3.9-5-3.9-2.45,0-5.95.06-5.95.06V32.43s2,.06,3.67.06a10.67,10.67,0,0,0,4-.41c1-.52,1.17-2.91,1.17-2.91h2s-.12,3.09-.12,4.43.12,4.37.12,4.37h-2a3.61,3.61,0,0,0-.76-2.51c-.7-.7-1.92-.81-4.08-.81-1.75,0-4,.06-4,.06s.06,6.24.06,6.76c0,1.69,0,4,.64,4.49.82.82,2.51.87,4.84.87,1.92,0,4.32-.29,5.42-1.29a5.48,5.48,0,0,0,1.34-3.14h2.1s-.12,2.44-.12,4.66c0,.58.12,2,.12,2S423.44,48.87,419.64,48.93Z" transform="translate(-10.37 -9.64)"></path>
        </svg>
      </b-navbar-brand>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item :to="'/courses'">Courses</b-nav-item>
        </b-navbar-nav>

        <b-navbar-nav>
          <b-nav-item :to="'/programs'">Programs</b-nav-item>
        </b-navbar-nav>

        <!-- <b-navbar-nav>
          <b-nav-item :to="'/subject'">Subjects</b-nav-item>
        </b-navbar-nav> -->

        <!-- <b-navbar-nav>
          <b-nav-item :to="'/careers'">Careers</b-nav-item>
        </b-navbar-nav> -->

        <b-navbar-nav>
          <b-nav-item :to="'/transfers'">Transfer Guides</b-nav-item>
        </b-navbar-nav>

        <div class="hold-nav-right">
          <b-button @click="showCart()" v-if="!isCartShow && $parent.cart.length > 0" class="cart-btn animated fadeIn fast" variant="outline-light">
            <i class="far fa-backpack animated infinite tada slow delay-1s"></i><span> Backpack</span> ({{$parent.cart.length}})
          </b-button>

          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-lg-2">
            <b-nav-form v-on:submit.prevent="sendSearch()" class="top-search-form">
              <label for="searchTypeNavSelect" class="type-label text-white">Search Type</label>
              <b-form-select
                v-model="searchType"
                :options="searchOptions"
                size="sm"
                id="searchTypeNavSelect"
                class="searchTypeSelect"
                :style="`width: ${searchTypeItem.w}px`"
                @change="checkSearchType($event)">
              </b-form-select>
              <label for="top-search" id="top-search-label">Search</label>
              <b-form-input @focus="selectSearch()" @blur="removeSearch()" autocomplete="off" size="sm" class="mr-sm-2" v-model="search" placeholder="Search" v-on:keyup.escape="clearSearch()" id="top-search" ref="searchBoxTop"></b-form-input>
              <b-button class="clear-search" v-if="search.length > 0" @click="clearSearch()" aria-label="Clear Search"><i class="fas fa-times"></i></b-button>
              <b-button size="sm" class="my-2 my-sm-0 search-btn" type="button" @click="sendSearch()" aria-label="Search"><i class="fas fa-search"></i></b-button>
            </b-nav-form>

<!--
            <b-nav-item-dropdown right>
              Using 'button-content' slot
              <template slot="button-content"><em>User</em></template>
              <b-dropdown-item href="#">Profile</b-dropdown-item>
              <b-dropdown-item href="#">Sign Out</b-dropdown-item>
            </b-nav-item-dropdown> -->
          </b-navbar-nav>
        </div>
      </b-collapse>

      <div id="searchDrop" class="wrapper" v-if="search.length > 0" :total-rows="rows" :per-page="perPage">

        <b-alert show dismissible @dismissed="clearSearch()" class="searchAlert">
          Searching <b>{{searchTypeItem.text}}</b> for:
          <b>{{search}}</b>
        </b-alert>

        <p v-for="searchItem in lists" :key="searchItem.index">
          <!-- COURSES -->
          <router-link :to="`/${searchItem.item.type}s/${searchItem.item.id}/${makeSlug(searchItem.item.name)}`" v-if="searchItem.item.type === 'course'" class="animated fadeIn faster">
            <b-badge variant="info" class="mr-2">{{searchItem.item.type}}</b-badge>
            <span>{{searchItem.item.id}} - {{ searchItem.item.name }}</span>
          </router-link>
          <!-- PROGRAMS -->
          <router-link :to="makeProgLink(searchItem.item)" v-if="searchItem.item.type === 'program' && searchItem.item.status !== 'Retiring'" class="animated fadeIn faster">
            <b-badge variant="primary" v-if="searchItem.item.degType === 'cert'" class="mr-2">certificate</b-badge>
            <b-badge variant="warning" v-else class="mr-2">degree</b-badge>
            <span>{{ searchItem.item.progName }}</span>
          </router-link>
          <!-- SUBJECTS -->
          <router-link :to="`/${searchItem.item.type}s/${encodeURIComponent(searchItem.item.code)}/${makeSlug(searchItem.item.name)}`" v-if="searchItem.item.type === 'subject'" class="animated fadeIn faster">
            <b-badge variant="success" class="mr-2">{{searchItem.item.type}}</b-badge>
            <span>{{searchItem.item.code}} - All {{ searchItem.item.name }} Courses</span>
          </router-link>
          <!-- TRANSFERS -->
          <template v-if="searchItem.item.type === 'transfer-school'">
            <router-link :to="`/${searchItem.item.type}s/${encodeURIComponent(searchItem.item.shortname)}`" v-if="foundGuides(searchItem.item) > 0" class="animated fadeIn faster transfer-block">
              <div>
                <b-badge variant="danger" class="mr-2">transfer guide</b-badge>
                <span>{{ searchItem.item.name }}</span>
              </div>
              <span class="transfer-lister">Found {{foundGuides(searchItem.item)}} related transfer guides</span>
            </router-link>

            <router-link :to="`/${searchItem.item.type}s/${encodeURIComponent(searchItem.item.shortname)}`" class="animated fadeIn faster" v-else>
              <b-badge variant="danger" class="mr-2 school-badge-darken">transfer school</b-badge>
              <span>{{ searchItem.item.name }}</span>
            </router-link>
          </template>
          <!-- CAREER SEARCH -->
          <router-link :to="`/${searchItem.item.type}s/${searchItem.item.code}/${makeSlug(searchItem.item.name)}`" v-if="searchItem.item.type === 'career'" class="animated fadeIn faster">
            <b-badge class="career-badge mr-2">{{searchItem.item.type}}</b-badge>
            <span>{{ searchItem.item.name }}</span>
          </router-link>
        </p>
        <p v-if="searchList.length === 0 && hasSearchItems">No Results</p>
        <!-- <p v-if="searchList.length === 0 && !hasSearchItems">Refine <span class="text-danger">"{{search}}"</span></p> -->
        <!-- <b-pagination v-model="searchList" per-page="8" aria-controls="searchDrop"></b-pagination> -->
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="searchDrop"
          v-if="rows > perPage"
          class="mt-3"
        >
        </b-pagination>
        <b-button @focus="showCloseBtn()" @blur="remSearchAll()" @click="remSearchAll()" class="hiddenSearchClose" :class="{isShow: showClose}">Close</b-button>
      </div>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <div class="cart-all animated fadeIn" v-if="$parent.cart.length > 0 && isCartShow" ref="cartAll">
        <h3 class="m-0 pt-3 px-2 pb-3 text-center"><i class="far fa-backpack"></i> Backpack</h3>
        <b-button @click="hideCart()" v-if="isCartShow" variant="primary" class="align-items-center close-pack" aria-label="Close Backpack">
          <i class="far fa-times"></i>
        </b-button>
        <!-- <b-button v-b-modal.modal-1>about backpack</b-button>
        <b-modal id="modal-1" title="BootstrapVue">
          <p class="my-4">Hello from modal!</p>
        </b-modal> -->
        <div class="cart-hold animated fadeInDown" ref="cartHold">
          <draggable v-model="$parent.cart" @start="drag=true" @end="drag=false" handle=".handle">

            <div class="d-flex flex-row align-items-center" v-for="item in $parent.cart" :key="item.index">
              <!-- CART CERT -->
              <b-list-group-item v-if="item.type === 'programs' && item.product.type === 'cert'" variant="primary" class="w-100 d-flex align-items-center">
                <i class="fa fa-align-justify handle"></i>
                <router-link :to="`/${item.type}/${encodeURIComponent(item.id)}`">{{item.id}}</router-link>
                <b-badge class="ml-2 mr-3" variant="primary">certificate</b-badge>
                <b-button variant="danger" class="trash-badge ml-auto" @click="$emit('delete', item.id, item.type)"><i class="fas fa-trash-alt"></i></b-button>
              </b-list-group-item>
              <!-- CART DEGREE -->
              <b-list-group-item v-if="item.type === 'programs' && item.product.type === 'degree'" variant="warning" class="w-100 d-flex align-items-center">
                <i class="fa fa-align-justify handle"></i>
                <router-link :to="`/${item.type}/${encodeURIComponent(item.id)}`">{{item.id}}</router-link>
                <b-badge class="ml-2 mr-3" variant="warning">degree</b-badge>
                <b-button variant="danger" class="trash-badge ml-auto" @click="$emit('delete', item.id, item.type)"><i class="fas fa-trash-alt"></i></b-button>
              </b-list-group-item>
              <!-- CART COURSES -->
              <b-list-group-item v-if="item.type === 'courses'" variant="info" class="w-100 d-flex align-items-center">
                <i class="fa fa-align-justify handle"></i>
                <router-link :to="`/${item.type}/${encodeURIComponent(item.id)}`">{{item.id}} - {{item.product.name}}</router-link>
                <b-badge class="ml-2 mr-3" variant="info">course</b-badge>
                <b-button variant="danger" class="trash-badge ml-auto" @click="$emit('delete', item.id, item.type)"><i class="fas fa-trash-alt"></i></b-button>
              </b-list-group-item>
              <!-- CART SUBJECTS -->
              <b-list-group-item v-if="item.type === 'subject'" variant="success" class="w-100 d-flex align-items-center">
                <i class="fa fa-align-justify handle"></i>
                <router-link :to="`/${item.type}/${encodeURIComponent(item.id)}`">All <span class="font-weight-bold">{{item.id}}</span> Courses</router-link>
                <b-badge class="ml-2 mr-3" variant="success">subject</b-badge>
                <b-button variant="danger" class="trash-badge ml-auto" @click="$emit('delete', item.id, item.type)"><i class="fas fa-trash-alt"></i></b-button>
              </b-list-group-item>
              <!-- CART CAREERS -->
              <b-list-group-item v-if="item.type === 'careers'" variant="secondary" class="w-100 d-flex align-items-center">
                <i class="fa fa-align-justify handle"></i>
                <router-link :to="`/${item.type}/${encodeURIComponent(item.product.code)}`"><span class="font-weight-bold">{{item.product.career.title}}</span> Career Info</router-link>
                <b-badge class="ml-2 mr-3" variant="secondary">career</b-badge>
                <b-button variant="danger" class="trash-badge ml-auto" @click="$emit('delete', item.id, item.type)"><i class="fas fa-trash-alt"></i></b-button>
              </b-list-group-item>
              <!-- CART TRANSFER -->
              <b-list-group-item v-if="item.type === 'transfer'" variant="danger" class="w-100 d-flex align-items-center">
                <i class="fa fa-align-justify handle"></i>
                <a :href="`${item.product.AGREEMENT_LINK}`" target="_blank">
                  <span class="font-weight-bold">{{item.product.FOUR_YEAR_SCHOOL_NAME}} - {{item.product.FOUR_YEAR_MJR}} ({{item.product.FOUR_YEAR_CRED}})</span>
                </a>
                <b-badge class="ml-2 mr-3" variant="danger">Transfer Guide</b-badge>
                <b-button variant="danger" class="trash-badge ml-auto" @click="$emit('delete', item.id, item.type)"><i class="fas fa-trash-alt"></i></b-button>
              </b-list-group-item>
            </div>
          </draggable>
        </div>
        <b-row class="cart-controls animated fadeInDown" ref="cartControls">
          <b-col class="d-flex justify-content-end pr-3">
            <!-- <b-button variant="primary" class="ml-3" @click="$emit('getLink')">
               Generate Link <i class="fas fa-arrow-circle-right pl-1"></i>
            </b-button> -->
            <b-button v-if="cartHasCourses" variant="success" class="ml-3" @click="$emit('register')">
              Schedule Courses <i class="far fa-cabinet-filing pl-1"></i>
            </b-button>
            <b-button variant="primary" class="ml-3" @click="$emit('send')">
               Send Backpack <i class="fas fa-arrow-circle-right pl-1"></i>
            </b-button>
            <b-button variant="danger" class="ml-3" @click="$emit('delete', 'all', 'all')">
              <i class="fas fa-trash-alt pr-1"></i> Delete All
            </b-button>
          </b-col>
        </b-row>
      </div>

    </b-navbar>
    <div class="year-list">
      <b-dropdown :text="`${theYear}`" variant="primary">
        <b-dropdown-item v-for="(item, index) in yearList" :key="index" :href="item.link" :target="item.target" @click="updateSelectedYear(item)">{{item.year}}</b-dropdown-item>
      </b-dropdown>
    </div>
  </b-container>

  <transition name="fade" mode="out-in">
    <b-button id="toTopBtn" @click="goTop()" v-show="scrollY > 400"><i class="fa fa-chevron-up" aria-hidden="true"></i>Top</b-button>
  </transition>
  </div>
</template>

<script>

// import localForage from 'localforage';
import Fuse from 'fuse.js';
import draggable from 'vuedraggable';
import Slug from '../scripts/slugMaker';

// import store from '../store';

// import sw from 'stopword';

export default {
  name: 'Navbar',
  data() {
    return {
      search: '',
      scrollTimer: 0,
      scrollY: 0,
      hasSearchItems: false,
      isCartShow: false,
      perPage: 10,
      currentPage: 1,
      cartLink: '',
      theYear: '2025-2026',
      activeSearch: false,
      showClose: false,
      searchOptions: [
        { value: 'all', text: 'All', w: 55 },
        { value: 'program', text: 'Programs of Study', w: 155 },
        { value: 'course', text: 'Courses', w: 90 },
        { value: 'transfer-school', text: 'Transfer Guides', w: 140 },
        { value: 'career', text: 'Careers', w: 90 },
        { value: 'subject', text: 'Subject Areas', w: 125 },
      ],
      searchTypeItem: { value: 'all', text: 'All', w: 55 },
      searchType: 'all',
      yearList: [
        { year: '2025-2026', link: '/', target: '' },
        { year: '2024-2025', link: '/2024-2025', target: '' },
        { year: '2023-2024', link: '/2023-2024', target: '' },
        { year: '2022-2023', link: '/2022-2023', target: '' },
        { year: '2021-2022', link: '/2021-2022', target: '' },
        /* { year: '2021-2022', link: 'https://catalog.cscc.edu/year/2021-2022', target: '_blank' },
        { year: '2020-2021', link: 'https://catalog.cscc.edu/year/2020-2021', target: '_blank' },
        { year: '2019-2020', link: 'https://catalog.cscc.edu/year/2019-2020', target: '_blank' },
        { year: '2018-2019', link: 'https://catalog.cscc.edu/year/2018-2019', target: '_blank' },
        { year: '2017-2018', link: 'https://catalog.cscc.edu/year/2017-2018', target: '_blank' }, */
      ],
    };
  },
  components: {
    draggable,
  },
  props: [
    'products',
    'searchTerm',
    'cartHasCourses',
  ],
  beforeRouteLeave(to, from, next) {
    this.search = '';
    this.hasSearchItems = false;
    this.showClose = false;
    this.activeSearch = false;
    next();
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    // console.log('navbar happens');
    /* const loadSearch = Promise.resolve(this.$store.dispatch('loadDataItem', {
      key: 'searchList',
      url: 'getCatalogItem?type=search&item=all',
      commit: 'mutateSearch',
      source: 'navbar',
    }));
    loadSearch.then((val) => {
      this.searchItems = val;
    }).then(() => {
      this.isCartShow = this.$store.state.isCartShow;
    }); */
  },
  methods: {
    handleScroll() {
      if (this.scrollTimer) return;
      this.scrollTimer = setTimeout(() => {
        this.scrollY = window.scrollY;
        clearTimeout(this.scrollTimer);
        this.scrollTimer = 0;
      }, 100);
    },
    goTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
    makeProgLink(item) {
      const name = item.progName;
      const slugged = Slug.makeSlug(name);
      if (item.alpha === '') {
        return { name: 'programNamed', params: { name, alpha: '' } };
      }
      return { name: 'programSlug', params: { alpha: item.alpha, slug: slugged } };
    },
    makeSlug(slug) {
      const val = Slug.makeSlug(slug);
      return val;
    },
    foundGuides(item) {
      const schoolFound = [JSON.parse(JSON.stringify(item))];
      let { transferItems } = schoolFound[0];
      if (transferItems === undefined) { transferItems = []; }
      const options = {
        ignoreLocation: true,
        maxPatternLength: 32,
        minMatchCharLength: 2,
        threshold: 0.1,
        keys: [
          { name: 'cscc_progs', weight: 0.1 },
          { name: 'name', weight: 0.1 },
        ],
      };
      const fuse = new Fuse(transferItems, options);
      const result = fuse.search(this.search);
      return result.length;
    },
    checkSearchType(selected) {
      let item = this.searchOptions[0];
      for (let i = 0; i < this.searchOptions.length; i += 1) {
        if (this.searchOptions[i].value === selected) {
          item = this.searchOptions[i];
        }
      }
      this.searchTypeItem = item;
      this.$refs.searchBoxTop.focus();
    },
    showCloseBtn() {
      this.showClose = true;
    },
    remSearchAll() {
      // console.log('focused?');
      this.search = '';
      this.showClose = false;
      this.activeSearch = false;
      document.body.style.overflow = 'auto';
    },
    removeSearch() {
      if (this.search.length > 0) { return; }
      this.activeSearch = false;
      document.body.style.overflow = 'auto';
    },
    selectSearch() {
      this.activeSearch = true;
      document.body.style.overflow = 'hidden';
    },
    updateSelectedYear(item) {
      if (item.target !== '') { return; }
      this.theYear = item.year;
    },
    checkFers(items) {
      const theseTransfers = items;
      let theItemsFound = 0;
      const options = {
        shouldSort: true,
        threshold: 0.2,
        maxPatternLength: 32,
        keys: ['transferItems'],
      };
      const fuse = new Fuse(theseTransfers, options);
      const result = fuse.search(this.search);
      theItemsFound = result.length;
      if (theItemsFound === 0) {
        return '';
      }
      if (theItemsFound > 1) {
        return `found ${theItemsFound} related transfer options`;
      }
      return `found ${theItemsFound} related transfer option`;
    },
    /* async loadSearch() {
      await localForage.getItem('searchList').then((value) => {
        if (value === null) {
          fetch(`${this.$store.state.generalSettings.apiUrl}/getCatalogItem?type=search&item=all`)
            .then(response => response.json())
            .then((data) => {
              this.$store.commit('loadSearch', data);
              this.searchItems = this.$store.state.searchList.items;
            });
        } else {
          this.searchItems = value.items;
        }
      });
    }, */
    clearSearch() {
      this.search = '';
      this.activeSearch = false;
      document.body.style.overflow = 'auto';
    },
    sendSearch() {
      if (this.search.length < 1) { return; }
      document.body.style.overflow = 'auto';
      this.$emit('updateSearch', this.search);
      this.$router.push({ name: 'search', query: { q: this.search } });
      // console.log(this.search);
      this.search = '';
    },
    showCart() {
      this.isCartShow = true;
      this.$store.commit('changeCartShow');
      // TODO CHANGE TO v-show
      // console.log(this.$parent.cart);
      setTimeout(
        () => {
          const { cartHold, cartControls, cartAll } = this.$refs;

          cartHold.classList.remove('animated', 'fadeOutUp');
          cartHold.classList.add('animated', 'fadeInDown');

          cartControls.classList.remove('animated', 'fadeOutUp');
          cartControls.classList.add('animated', 'fadeInDown');

          cartAll.classList.remove('animated', 'fadeOut');
          cartAll.classList.add('animated', 'fadeIn', 'borderCart');
        },
        10,
      );
    },
    hideCart() {
      const { cartHold, cartControls, cartAll } = this.$refs;

      cartHold.classList.remove('animated', 'fadeInDown');
      cartHold.classList.add('animated', 'fadeOutUp');

      cartControls.classList.remove('animated', 'fadeInDown');
      cartControls.classList.add('animated', 'fadeOutUp');

      cartAll.classList.remove('animated', 'fadeIn', 'borderCart');
      cartAll.classList.add('animated', 'fadeOut');

      cartAll.addEventListener('animationend', () => {
        this.isCartShow = false;
      });
      this.$store.commit('changeCartShow');
    },
  },
  computed: {
    searchItems() {
      return this.$parent.searchItems;
    },
    lists() {
      const items = this.searchList;
      if (this.search.length < 2) { return items; }
      // Return just page of items needed
      return items.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage,
      );
    },
    rows() {
      return this.searchList.length;
    },
    searchList() {
      const options = {
        shouldSort: true,
        ignoreLocation: true,
        threshold: 0.2,
        useExtendedSearch: true,
        includeMatches: true,
        findAllMatches: true,
        minMatchCharLength: 2,
        maxPatternLength: 48,
        keys: [
          { name: 'id', weight: 2 },
          { name: 'progName', weight: 50 },
          { name: 'name', weight: 2 },
          { name: 'code', weight: 2 },
          { name: 'subj', weight: 2 },
          { name: 'shortname', weight: 2 },
          { name: 'relatedWords', weight: 0.5 },
          { name: 'transferItems.cscc_progs', weight: 1 },
          { name: 'transferItems.name', weight: 1 },
        ],
      };

      if (this.search.length > 48) {
        return 0;
      }
      const fuse = new Fuse(this.searchItems, options);

      if (this.search.length >= 2) {
        const result = fuse.search(this.search);
        let retResult = result;
        if (this.searchType !== 'all') {
          retResult = [];
          for (let i = 0; i < result.length; i += 1) {
            if (result[i].item.type === this.searchType) {
              retResult.push(result[i]);
            }
          }
        }
        return retResult;
      }
      return 0;
    },
  },
};
</script>

<style lang="scss">
  .nav-container {
    background-color: #002d3c;
    height: 5rem;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);
    position: fixed;
    top: 2.8rem;
    z-index: 9000;
  }
  .navbar-toggler {
    margin: 0 !important;
  }
  #main-nav {
    height: 5rem;
    max-width: 1140px;
    margin-left: calc(50% - (1140px / 2));
    @media screen and (max-width: 1199px) {
      max-width: 960px;
      margin-left: calc(50% - (960px / 2));
    }
    @media screen and (max-width: 991px) {
      max-width: 740px;
      margin-left: calc(50% - (740px / 2));
    }
    @media screen and (max-width: 767px) {
      max-width: 540px;
      margin-left: calc(50% - (540px / 2));
    }
    @media screen and (max-width: 576px) {
      max-width: 100%;
      margin-left: 0;
    }
  }
  .navbar-nav {
    .form-inline {
      flex-flow: row nowrap;
    }
    /* .search-btn {
      margin-left: 10px;
    } */
  }
  .search-helper {
    border: 0 !important;
    span {
      color: red;
    }
  }
  .cart-all {
    background-color: white;
    display: flex;
    flex-direction: column;
    position: fixed;
    bottom: 50px;
    right: 50px;
    border: 0;
    border-radius: 0;
    box-shadow: 0 0 7px rgba(0,0,0,.2);
    h3 {
      height: 48px;
      padding: 0 1rem !important;
      margin-bottom: 1rem !important;
      background-color: #002d3c;
      color: white;
      display: flex;
      width: 100%;
      align-items: center;
      i {
        margin-right: .5rem;
      }
    }
    @media screen and (max-width: 767px) {
      bottom: 0;
      right: .5rem;
      width: calc(100% - 1rem);
    }
  }
  .cart-hold {
    border-radius: 0;
    background-color: white;
    padding: .5rem 1rem;
    padding-top: 0;
    max-height: calc(100vh - 7.8rem - 145px);
    max-width: 600px;
    // overflow-y: scroll;
    overflow-x: hidden;
    div {
      .list-group-item {
        padding: 0 .75rem 0 0;
      }
      .trash-badge {
        padding: .25rem .4rem .15rem;
        i {
          font-size: 1.2rem;
        }
      }
      a {
        color: black;
        padding: .75rem .25rem;
        line-height: 1.3;
      }
    }
    .handle {

      &:before {
        display: block;
        padding: 1.25rem;
      }

    }
  }
  .cart-btn {
    border-color: rgba(255, 255, 255, 0.2) !important;
    &:hover {
      background-color: #007298 !important;
    }
    @media screen and (max-width: 991px) {
      padding: .5rem .35rem !important;
      border-radius: .2rem !important;
      margin-left: auto;
      margin-right: .5rem;

      span {
        display: none;
      }
    }
  }
  .cart-controls {
    border-radius: 0;
    border-top: 1px solid rgba(200,200,200,.4);
    /* border: 1px solid rgba(200,200,200,.4); */
    top: calc(100vh - 100px - 1rem);
    // left: 1rem !important;
    background-color: white;
    margin: 0 !important;
    margin-top: .5rem !important;
    display: block;
    .col {
      margin: 0 !important;
      padding: 1rem 0;
    }
  }
  .borderCart {
    border: 1px solid rgba(200,200,200,.8) !important;
  }
  .close-pack {
    position: absolute;
    border-radius: 0 !important;
    right: 0;
    padding: 0 !important;
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      font-size: 1.3rem;
      padding: 0;
      &:before {
        line-height: 1.3;
      }
    }
  }
  .transfer-block {
    display: flex;
    flex-direction: column;
  }
  .transfer-lister {
    width: 100%;
    font-size: .75rem;
    padding-left: 95px;
    color: #007298;
  }
  .top-search-form {
    form {
      label {
        font-size: 0;
      }
    }
  }
  .year-list {
    position: fixed;
    right: 0;
  }
  #top-search-label {
    color: white;
  }
</style>
